import React, { createContext, useContext, useState } from 'react';

const SecretEntryContext = createContext();

export const useSecretEntryContext = () => useContext(SecretEntryContext);

export const SecretEntryProvider = ({ children }) => {
    const [secretEntryState, setSecretEntryState] = useState({
        jobid: '',
        jobcode: '',
        secreteactivestatus: 'all',
    });

    // This function updates the context state
    const updateSecretEntryState = (newState) => {
        setSecretEntryState((prevState) => ({ ...prevState, ...newState }));
    };

    return (
        <SecretEntryContext.Provider value={{ secretEntryState, updateSecretEntryState }}>
            {children}
        </SecretEntryContext.Provider>
    );
};
